export function longDate(date: string): string {
  return new Date(date).toLocaleDateString('no', {dateStyle: 'long'})
}

export function dateIsoString(date: Date) {
  const yyyy = date.getFullYear()
  const mm = (date.getMonth() + 1).toString().padStart(2, '0')
  const dd = date.getDate().toString().padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

export function isoStringToLocaleString(dateString?: string) {
  return dateString && new Date(dateString).toLocaleDateString('no', {dateStyle: 'long'})
}

export function isoStringRangeToLocaleStringRange(fromDateString?: string, toDateString?: string) {
  const from = isoStringToLocaleString(fromDateString)
  const to = isoStringToLocaleString(toDateString)
  if(from && to) {
    return `Fra ${from} til ${to}`
  } else if(from) {
    return `Fra ${from}`
  } else if(to) {
    return `Til ${from}`
  } else {
    return ''
  }
}